<template>
    <footer class="cabinet__footer">
        <div class="cabinet__footer-content">
            <div class="cabinet__footer-column">
                <div class="cabinet__footer-copy">
                    © {{ new Date().getFullYear() }} {{ appName }}
                </div>
                <div class="cabinet__footer-socials">
                    <a
                        href="https://vk.com/russianjewellerru"
                        target="_blank"
                        class="cabinet__footer-socials-item cabinet__footer-socials-item--vk"
                    ></a>
                </div>
            </div>
            <div class="cabinet__footer-column">
                <div class="cabinet__footer-title">Категории</div>
                <ul class="cabinet__footer-menu">
                    <li v-for="categorie in categories" :key="categorie.id">
                        <router-link
                            :to="{
                                name: 'CategoryID',
                                params: { id: categorie.url }
                            }"
                            >{{ categorie.name }}</router-link
                        >
                    </li>
                </ul>
            </div>
            <div class="cabinet__footer-column">
                <div class="cabinet__footer-title">Партнерам</div>
                <ul class="cabinet__footer-menu">
                    <li>
                        <router-link to="/partners"
                            >Приглашение к сотрудничеству</router-link
                        >
                    </li>
                    <li>
                        <a href="mailto:info@goldnet.market"
                            >Связаться с нами</a
                        >
                    </li>
                    <li v-if="!user">
                        <a href="/auth/login">Вход для партнеров</a>
                    </li>
                </ul>
            </div>
            <div class="cabinet__footer-column">
                <div class="cabinet__footer-title">Информация</div>
                <ul class="cabinet__footer-menu">
                    <li>
                        <a
                            href="https://docs.goldnet.market/doku.php?id=user_agreement"
                            >Пользовательское соглашение</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://docs.goldnet.market/doku.php?id=privacy_policy"
                            >Конфиденциальность</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import settings from '@/settings.js'

export default {
    name: 'CabinetFooter',
    data() {
        return {
            appName: settings.APP_NAME
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapGetters('user', ['isRetailer']),
        ...mapGetters('publicCategories', ['categories', 'loading'])
    }
}
</script>
